import { adminMutation } from "@/admin/utils/adminMutation.ts";
import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import { atomFamilyMulti } from "@/utils/jotai/atomFamilyMulti.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { MetalCommitmentOfferResponse } from "@warrenio/api-spec/spec.oats.gen";

type Response = MetalCommitmentOfferResponse;

function getQueryKey(params?: Params): QueryKey {
    return params == null
        ? ["metal/admin_commitment_offer"]
        : ["metal/admin_commitment_offer", params.location, params.uuid];
}

interface Params {
    location: string;
    uuid: string;
}

function getQuery(client: ApiClient, params: Params) {
    return queryOptions({
        queryKey: getQueryKey(params),
        queryFn: async ({ signal }): Promise<Response> => {
            const { location, uuid } = params;
            return getResponseData(
                await client.GET("/{location}/admin/metal/commitment_offers/{uuid}", {
                    signal,
                    params: { path: { location, uuid } },
                }),
            );
        },
    });
}

export const commitmentOfferLocationQueryAtom = atomFamilyMulti((location: string, uuid: string) =>
    atomFromStandardQueryOptions(getQuery, { location, uuid }),
);

//#region Mutations
const entity = "Period";

export const commitmentOfferUpdateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "update",
    requestFn: async ({
        body,
        location,
        uuid,
    }: {
        body: MetalCommitmentOfferResponse;
        location: string;
        uuid: string;
    }) =>
        await apiClient.PUT("/{location}/admin/metal/commitment_offers/{uuid}", {
            ...jsonEncodedBody,
            body,
            params: { path: { location, uuid } },
        }),
    invalidateQueryKey: getQueryKey,
}));

//#endregion
